module.exports = __webpack_public_path__ + "img/BRANDING02_VESTA.d62cb591.jpg";